var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#E3E6ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5789 17.3824C30.5789 19.274 29.0386 20.8144 27.1469 20.8144H8.47363V7.22154C8.47363 5.32989 10.014 3.78955 11.9056 3.78955H30.5789V17.3824Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.498 13.8963H25.9168C25.9573 13.8963 26.0519 13.8827 26.0924 13.8827C26.3627 13.8287 26.5924 13.5855 26.5924 13.2477C26.5924 12.9234 26.3627 12.6802 26.0924 12.6126C26.0519 12.5991 25.9708 12.5991 25.9168 12.5991H24.498V13.8963Z",
    fill: "url(#paint0_linear_736_4528)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7549 4.93799C24.4037 4.93799 23.2957 6.03244 23.2957 7.39713V9.95086H26.7683C26.8493 9.95086 26.9439 9.95086 27.0115 9.96437C27.7952 10.0049 28.3762 10.4103 28.3762 11.1129C28.3762 11.6669 27.9843 12.1398 27.2547 12.2343V12.2614C28.0519 12.3154 28.6599 12.7613 28.6599 13.4504C28.6599 14.1936 27.9843 14.68 27.0925 14.68H23.2822V19.6793H26.8899C28.241 19.6793 29.349 18.5849 29.349 17.2202V4.93799H25.7549Z",
    fill: "url(#paint1_linear_736_4528)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4167 11.2752C26.4167 10.9509 26.187 10.7347 25.9168 10.6942C25.8898 10.6942 25.8222 10.6807 25.7817 10.6807H24.498V11.8697H25.7817C25.8222 11.8697 25.9033 11.8697 25.9168 11.8562C26.187 11.8157 26.4167 11.5995 26.4167 11.2752Z",
    fill: "url(#paint2_linear_736_4528)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1626 4.93799C10.8114 4.93799 9.70345 6.03244 9.70345 7.39713V13.4639C10.3926 13.8017 11.1087 14.0179 11.8248 14.0179C12.676 14.0179 13.1354 13.5045 13.1354 12.8018V9.93735H15.2433V12.7883C15.2433 13.8963 14.5542 14.8016 12.2166 14.8016C10.7979 14.8016 9.68994 14.4908 9.68994 14.4908V19.6658H13.2976C14.6488 19.6658 15.7567 18.5714 15.7567 17.2067V4.93799H12.1626Z",
    fill: "url(#paint3_linear_736_4528)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9587 4.93799C17.6075 4.93799 16.4995 6.03244 16.4995 7.39713V10.6129C17.1211 10.086 18.202 9.74818 19.945 9.82925C20.8773 9.86979 21.8772 10.1265 21.8772 10.1265V11.1669C21.3773 10.9102 20.7827 10.6805 20.0126 10.6264C18.6884 10.5319 17.8912 11.1804 17.8912 12.3154C17.8912 13.4639 18.6884 14.1125 20.0126 14.0044C20.7827 13.9503 21.3773 13.7071 21.8772 13.4639V14.5043C21.8772 14.5043 20.8908 14.761 19.945 14.8016C18.202 14.8827 17.1211 14.5449 16.4995 14.0179V19.6928H20.1072C21.4583 19.6928 22.5663 18.5984 22.5663 17.2337V4.93799H18.9587Z",
    fill: "url(#paint4_linear_736_4528)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_736_4528",
    x1: 23.2932,
    y1: 13.2493,
    x2: 29.3651,
    y2: 13.2493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_736_4528",
    x1: 23.2933,
    y1: 12.3028,
    x2: 29.3656,
    y2: 12.3028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_736_4528",
    x1: 23.2931,
    y1: 11.2735,
    x2: 29.3652,
    y2: 11.2735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_736_4528",
    x1: 9.70059,
    y1: 12.3028,
    x2: 15.8664,
    y2: 12.3028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_736_4528",
    x1: 16.4646,
    y1: 12.3028,
    x2: 22.453,
    y2: 12.3028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.881e760b6cfcfc0716b0b272ab5aef98.svg";
export { ForwardRef as ReactComponent };